<div class="ddt-container">
    <app-ddt-add (ddtAdded)="handleDdtAdd($event)" [ddt]="ddt"></app-ddt-add>
    <app-ddt-list [reloadDataSubject]="reloadSubject.asObservable()" t></app-ddt-list>
</div>
